// 根据时间及关键字搜索

import React, { Component } from 'react';
import { DatePicker, Radio, Form, Input, Button } from 'antd';
import moment from 'moment';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const dateFormat = 'YYYY-MM-DD';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChange1 = e => {
    const {
      form: { setFieldsValue },
    } = this.props;
    const {
      target: { value },
    } = e;
    if (value === '0') {
      setFieldsValue({
        range: [null, null],
      });
    } else if (value === '1') {
      const start = moment().startOf('month');
      const end = moment().endOf('month');
      setFieldsValue({
        range: [start, end],
      });
    } else if (value === '2') {
      const start = moment().startOf('year');
      const end = moment().endOf('year');
      setFieldsValue({
        range: [start, end],
      });
    }
  };

  onChange2 = () => {
    const {
      form: { setFieldsValue },
    } = this.props;
    setFieldsValue({ type: undefined });
  };

  onSearch = () => {
    const value = this.props.form.getFieldsValue();
    const params = {};
    if (value.range) {
      params.beginDate = value.range[0] ? moment(value.range[0]).format('YYYY-MM-DD') : '';
      params.endDate = value.range[1] ? moment(value.range[1]).format('YYYY-MM-DD') : '';
    }
    this.props.onChange({
      ...params,
      condition: value.condition || '',
    });
  };

  onReset = () => {
    this.props.form.resetFields();
    this.props.onChange({});
  };

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form style={{ textAlign: 'right' }} layout="inline">
        <FormItem>
          {getFieldDecorator('type')(
            <RadioGroup onChange={this.onChange1}>
              <RadioButton value="0">全部</RadioButton>
              <RadioButton value="1">本月</RadioButton>
              <RadioButton value="2">本年</RadioButton>
            </RadioGroup>,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('range', {
            initialValue: this.props.beginDate
              ? [moment(this.props.beginDate, dateFormat), moment(this.props.endDate, dateFormat)]
              : null,
          })(<RangePicker style={{ marginLeft: '-10px' }} onChange={this.onChange2} />)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('condition', {
            initialValue: this.props.condition || null,
          })(<Input style={{ marginLeft: '8px' }} placeholder="请输入关键字" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" style={{ marginLeft: '8px' }} onClick={this.onSearch}>
            搜索
          </Button>
          <Button style={{ marginLeft: '8px', marginRight: '-16px' }} onClick={this.onReset}>
            重置
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/comm/search/DateConditionSearch.js